import request from '../utils/request';

//展商直播新增
export function addLive(data) {
  return request({
    url: '/frontExhibitor/zsLive/saveOrEdit',
    method: 'post',
    data: data,
  });
};

//展商直播列表
export function liveList(data) {
  return request({
    url: '/frontExhibitor/zsLive/list',
    method: 'get',
    params: data,
  });
};

//展商直播修改排序
export function editSort(data) {
  return request({
    url: '/frontExhibitor/zsLive/editSort',
    method: 'get',
    params: data,
  });
};

//展商直播修删除
export function del(data) {
  return request({
    url: '/frontExhibitor/zsLive/delete',
    method: 'get',
    params: data,
  });
};
//展商直播审核状态统计
export function statistical() {
  return request({
    url: '/frontExhibitor/zsLive/countAudit',
    method: 'get',
  });
};
//展商id获取信息
export function getexhdeta(data) {
  return request({
    url: '/frontExhibitor/zsLive/view',
    method: 'get',
    params: data,
  });
};
